/**
 * Handles the hide/show logic of a collapsable details view
 */
'use strict';

var DetailsToggleWidget = function(elementID, elementToShowHideID) {
    this.initialize(elementID, elementToShowHideID);
};

DetailsToggleWidget.prototype = {
    $link: null,
    $label: null,
    $details: null,

    /**
     * Creates a new instance of the DetailsToggleWidget class
     * <b>Example:</b><br/>
     * To have a link which displayed an error log, you could have the following:<br/><br/>
     * <i>The Link</i>: <a href='#' class='detailsLink' detailsLink='errorLog'>Click here to <span viewLabel='view'
     * hideLabel="hide">view</span> the error log</a><br/><br/>
     * You'll note the following characteristics:
     * <ul>
     *    <li><i>class='detailsLink'</i>: REQUIRED - This indicates that this is a DetailedToggleWidget</li>
     *    <li><i>detailsLink='errorLog'</i>: REQUIRED - This indicates that this DetailedToggleWidget is tied to the element with the id of "errorLog"</li>
     *    <li><i><span viewLabel='view' hideLabel='hide'></i>: OPTIONAL - This optionally swaps the view label and hide label based upon the state of the toggle
     * </ul>
     *
     * And that's all there is to it.
     * @constructor
     * @member DetailsToggleWidget
     * @param {String/Object} elementID The id of the element to use as the clickable to show/hide
     * @param {String/Object} elementToShowHideID The id of the element object to show/hide
     */
    initialize: function (elementID, elementToShowHideID) {
        // Get the element from either an object or an id
        this.$link = jQuery('#' + elementID);
        if (this.$link.length === 0) {
            return;
        }

        this.$details = jQuery('#' + elementToShowHideID);
        if (this.$details.length === 0) {
            return;
        }

        if (this.$details.hasClass('hiddenDetails')) {
            this.$details.hide();
            this.$details.removeClass('hiddenDetails');
        }

        var $labelTemp = jQuery('#' + elementID + ' span');
        if ($labelTemp.length){
            this.$label = jQuery($labelTemp[0]);
        }

        this.$link.on('click', jQuery.proxy(this.toggle, this));
    },

    toggle: function(){
        if(!this.$details.is(':visible')){
            this.$details.show();
            if (this.$label){
                if (this.$label.attr('hideLabel')){
                    this.$label.html(this.$label.attr('hideLabel'));
                }
            }
            this.$link.removeClass('detailsLink');
            this.$link.addClass('detailsCollapsable');
        } else {
            this.$details.hide();
            if(this.$label) {
                if (this.$label.attr('viewLabel')) {
                    this.$label.html(this.$label.attr('viewLabel'));
                }
            }
            this.$link.addClass('detailsLink');
            this.$link.removeClass('detailsCollapsable');
        }
        return false;
    }
};

module.exports = DetailsToggleWidget;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/DetailsToggleWidget.js
// module id = 32
// module chunks = 0